
<datatable #datatable [definition]="tableDefinition" [data]="tableData" [autoUpdate]="false" stickyheaders></datatable>
<div class="footer">
  <div links>{{datatable.filterRijen}} / {{datatable.rijen}}
    <button class="btn btn-outline-light ml-2" title="Synchroniseer Exact" *ngIf="api.can('exact', 'sync') || api.can('project','full')" (click)="api.syncExact()"><span class="fas fa-sync"></span></button>
  </div>
</div>
